import { MemoryStorage } from "@Engage.Core";
import { AppStates } from "@Engage.Core";
const DEFAULT_TIMEOUT_MS = 5000;
/**
 * PromiseQualifier
 * The qualifier list sends each promise expression as an array entry (EvaluatedObject from config).
 * Evaluates and awaits each expression, returns { key: expression, value: resolvedResult }.
 *
 * The API stores item.Key → PromiseKey and item.Value → PromiseValue (last item wins).
 * CheckPromiseCondition uses PromiseValue directly against rule.Value with the qualifier operator.
 */
export class PromiseQualifier {
    constructor() {
        this.key = "Promise";
    }
    async process(config) {
        var _a;
        const entries = Array.isArray(config) ? config : [];
        const timeoutMs = (_a = MemoryStorage.get(AppStates.ConversationPromiseTimeout)) !== null && _a !== void 0 ? _a : DEFAULT_TIMEOUT_MS;
        const results = await Promise.all(entries
            .filter(e => e && typeof e === 'string')
            .map(async (expression) => ({
            key: expression, // item.Key → PromiseKey
            value: await this.resolve(expression, timeoutMs) // item.Value → PromiseValue
        })));
        return results;
    }
    async resolve(expression, timeoutMs) {
        try {
            // eslint-disable-next-line no-eval
            const evaluated = eval(expression);
            let resolved;
            if (evaluated && typeof evaluated.then === 'function') {
                resolved = await Promise.race([
                    evaluated,
                    new Promise((_, reject) => setTimeout(() => reject(new Error('PromiseQualifier timeout')), timeoutMs))
                ]);
            }
            else {
                resolved = evaluated;
            }
            if (resolved === undefined || resolved === null)
                return "";
            if (Array.isArray(resolved)) {
                return resolved
                    .filter(item => item !== undefined && item !== null)
                    .map(item => String(item).toLowerCase().trim())
                    .join(",");
            }
            return String(resolved).toLowerCase();
        }
        catch (_a) {
            return "";
        }
    }
}
